module.exports = __webpack_public_path__ + "static/media/26.9cf11d2d.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/26.JPG
// module id = 469
// module chunks = 0